const PUBLISHED_APP_ORIGIN = "https://lineupsync.club";

const isLovablePreviewOrigin = (origin: string) =>
  origin.includes("lovableproject.com") || origin.includes("-preview--") || origin.includes("localhost");

export const getAppOrigin = () => {
  if (typeof window === "undefined") return PUBLISHED_APP_ORIGIN;
  return isLovablePreviewOrigin(window.location.origin) ? PUBLISHED_APP_ORIGIN : window.location.origin;
};

export const buildAppUrl = (path = "/") => new URL(path, `${getAppOrigin()}/`).toString();